{
  "nav": "機房",
  "title": "機房",
  "subtitle": "機房管理站回報的網路、Wi-Fi 基地台、伺服器與 NAS 狀態（只能查看）。",
  "loading": "讀取中…",
  "not_found": "找不到可以查看的機房。",
  "col": {
    "site": "地點",
    "station": "機房管理站",
    "online": "連線"
  },
  "online": "在線",
  "offline": "離線",
  "tab": {
    "overview": "總覽",
    "router": "路由器",
    "ap": "Wi-Fi 基地台",
    "servers": "伺服器",
    "nas": "NAS"
  },
  "tool": {
    "site.status": "總覽",
    "net.devices": "已連線設備",
    "net.wan": "對外網路",
    "net.wifi": "Wi-Fi",
    "net.traffic": "流量",
    "net.dhcp.list": "固定 IP",
    "net.forward.list": "連接埠轉送",
    "net.logs": "日誌",
    "ap.status": "狀態",
    "ap.clients": "已連線用戶端",
    "ap.wifi": "Wi-Fi 設定",
    "srv.health": "伺服器",
    "nas.health": "NAS"
  },
  "refresh": "重新整理",
  "running": "查詢中…",
  "updated": "更新於 {{at}}",
  "wait": "（稍候 {{s}} 秒）",
  "error": "查詢失敗：{{code}}",
  "run_state": "查詢沒有完成：{{state}} {{code}}",
  "no_resources": "這台機房管理站沒有登記這類設備。"
}
